module.exports = __webpack_public_path__ + "img/233.a34b3064.jpg";